import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  timeout: 15000,
});

// Ensure trailing slash on all requests to avoid FastAPI 307 redirects
// (FastAPI redirects /foo → /foo/ but browsers drop the Authorization header on redirect)
api.interceptors.request.use(config => {
  if (config.url && !config.url.endsWith('/') && !config.url.includes('?')) {
    config.url = config.url + '/';
  }
  return config;
});

// Attach JWT token automatically
api.interceptors.request.use(config => {
  const stored = localStorage.getItem('nm_auth');
  if (stored) {
    try {
      const { token } = JSON.parse(stored);
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch {
      // malformed storage — ignore
    }
  }
  return config;
});

// Handle 401 globally — clear stored token so ProtectedRoute redirects to /login
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('nm_auth');
      // Don't hard-redirect here — let React Router's ProtectedRoute handle it
      // on the next render after Redux state is cleared by App.js logout
    }
    return Promise.reject(err);
  }
);

export default api;
